export function getApiErrorMessage(err, fallback = 'Request failed') {
  const response = err && err.response;
  if (!response) {
    return {
      message: (err && err.message) || fallback,
      fieldErrors: {},
    };
  }

  const data = response.data;
  const fieldErrors = {};

  if (data && typeof data === 'object' && data.errors && typeof data.errors === 'object') {
    Object.keys(data.errors).forEach((key) => {
      const messages = data.errors[key];
      if (Array.isArray(messages) && messages[0]) {
        fieldErrors[key] = messages[0];
      }
    });
  }

  let message = fallback;
  if (data && typeof data === 'object') {
    if (data.error) {
      message = data.error;
    } else if (data.message) {
      message = data.message;
    } else if (Object.keys(fieldErrors).length) {
      message = Object.values(fieldErrors)[0];
    }
  } else if (typeof data === 'string' && data.trim()) {
    message = data.trim();
  }

  return { message, fieldErrors };
}

export function mapApiFieldErrors(fieldErrors, fieldMap, errorsObj) {
  Object.keys(fieldMap).forEach((apiKey) => {
    if (fieldErrors[apiKey]) {
      errorsObj[fieldMap[apiKey]] = fieldErrors[apiKey];
    }
  });
}
